import { JbpListFiltersDto } from "../models/jbp-list.dto";

export class JbpAction_getItems {
  static readonly type = "[Jbp] get items";
  constructor(
    public data: {
      page?: number;
      filters?: JbpListFiltersDto;
    }
  ) {}
}

export class JbpAction_getPriority {
  static readonly type = "[Jbp] get priority";
}

export class JbpAction_getStrategies {
  static readonly type = "[Jbp] get strategies";
  constructor(public priorityId: number) {}
}

export class JbpAction_getActions {
  static readonly type = "[Jbp] get actions";
  constructor(public priorityId: number) {}
}

export class JbpAction_create {
  static readonly type = "[Jbp] create";
}

export class JbpAction_update {
  static readonly type = "[Jbp] update";
  constructor(public id: number) {}
}

export class JbpAction_comment {
  static readonly type = "[Jbp] comment";
  constructor(public id: number, public comment: string) {}
}

export class JbpAction_draft {
  static readonly type = "[Jbp] draft";
  constructor(public id: number, public draft: string) {}
}

export class JbpAction_export {
  static readonly type = "[Jbp] export";
  constructor(
    public data: {
      filename: string;
    }
  ) {}
}

export class JbpAction_download_pdf {
  static readonly type = "[Jbp] export pdf";
  constructor(public id: number, public clientName: string) {}
}

// export class JbpAction {
//   static readonly type = '[Jbp] Add item';
//   constructor(public payload: string) { }
// }
